import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { TipoContrato } from '@shared/models';
import { ResponseWrapper } from '@shared';
import { environment } from '@env';

const API_URL = environment.URL_SERVICIOSBACK;
const ENDPOINT_TIPO_CONTRATO = '/tipo-contrato';

@Injectable({
  providedIn: 'root',
})
export class TipoContratoService {
  private readonly API_URL_TIPO_CONTRATO = API_URL + ENDPOINT_TIPO_CONTRATO;
  private http = inject(HttpClient);

  listarTipoContrato(): Observable<TipoContrato[]> {
    return this.http.get<ResponseWrapper<TipoContrato[]>>(this.API_URL_TIPO_CONTRATO).pipe(
      map((res) => {
        return res.data;
      }),
    );
  }
}
